export const FULL_PERIOD_SEARCH_START_DATE = '2000-01-01';

export const getSearchAwareDateRange = ({ startDate, endDate, hasSearch, today }) => {
  if (!hasSearch) return { startDate, endDate };

  return {
    startDate: FULL_PERIOD_SEARCH_START_DATE,
    endDate: today || endDate,
  };
};

export const normalizePhoneSearch = (value) => String(value || '').replace(/\D/g, '');

export const includesNormalizedPhoneSearch = (phone, search) => {
  if (!String(search || '').trim()) return true;
  const normalizedSearch = normalizePhoneSearch(search);
  if (!normalizedSearch) return false;

  return normalizePhoneSearch(phone).includes(normalizedSearch);
};

export const normalizeTextSearch = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');

export const includesNormalizedTextSearch = (value, search) => {
  const normalizedSearch = normalizeTextSearch(search);
  if (!normalizedSearch) return true;

  return normalizeTextSearch(value).includes(normalizedSearch);
};
